import React from "react";
import { motion } from "framer-motion";
import "./AnimatedPlanning.css";
import {Link, Typography} from "@mui/material";

const saturdayItems = [
    {
        time: '15h00',
        title: 'Cérémonie civile',
        location: 'Mairie de Faremoutiers',
    },
    {
        time: '17h30',
        title: 'Cérémonie laïque',
        location: 'Domaine de la Pépinière',
    },
    {
        time: '18h45',
        title: 'Cocktail',
        location: 'Domaine de la Pépinière',
    },
    {
        time: '20h00',
        title: 'Repas & Soirée Dansante',
        location: 'Domaine de la Pépinière',
    }
];

const sundayItems = [
    {
        time: '10h30',
        title: 'Brunch',
        location: 'Domaine de la Pépinière',
    }
];

interface ScheduleProps {
    title: string;
    items: typeof saturdayItems;
}

const DaySchedule: React.FC<ScheduleProps> = ({ title, items }) => {
    const itemVariants = {
        hidden: { opacity: 0, y: 20 },
        visible: { opacity: 1, y: 0 },
    };

    const lineLength = items.length * 70;
    const totalDuration = 0.5 * items.length;

    const drawLine = {
        hidden: { pathLength: 0 },
        visible: { pathLength: 1, transition: { duration: totalDuration, ease: "easeInOut" } },
    };

    return (
        <motion.div className="schedule-content" initial="hidden" animate="visible">
            <motion.div
                className="program-title"
                initial={{ opacity: 0, y: -50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 0.3 }}
            >
                <Typography variant="h4" gutterBottom sx={{ mb: 4 }}>
                    {title}
                </Typography>
            </motion.div>

            <div className="schedule-list">
                <motion.svg
                    className="timeline-svg"
                    width="2"
                    height={lineLength}
                    viewBox={`0 0 2 ${lineLength}`}
                    initial="hidden"
                    animate="visible"
                >
                    <motion.line
                        x1="1"
                        y1="0"
                        x2="1"
                        y2={lineLength}
                        stroke="#CCCCCC"
                        strokeWidth="2"
                        variants={drawLine}
                    />
                </motion.svg>

                {items.map((item, index) => (
                    <motion.div
                        key={index}
                        className="schedule-item"
                        variants={itemVariants}
                        transition={{ duration: 0.5, delay: totalDuration * (index / items.length) + 0.5 }}
                    >
                        <div className="time-column">
                            <Typography variant="body1">{item.time}</Typography>
                        </div>
                        <div className="line-connector">
                            <div className="circle"></div>
                        </div>
                        <div className="details-column">
                            <Typography className="item-title" variant="body1" fontWeight={"bold"}>{item.title}</Typography>
                            <Link href="/howtocome" className="item-location-link"><Typography className="item-location" variant="body1">{item.location}</Typography></Link>
                        </div>
                    </motion.div>
                ))}
            </div>
        </motion.div>
    );
};

const Planning = () => {
    return (
        <div className="schedule-program-container">

            <DaySchedule title="Samedi 11 juillet" items={saturdayItems} />
            <DaySchedule title="Dimanche 12 juillet" items={sundayItems} />
        </div>
    );
};

export default Planning;
